import styled from "styled-components";

export const StyledHeader = styled.div`
  padding: 0 16px;
  width: 100%;
  height: 64px;
  background-color: teal;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const StyledHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  gap: 10px;
`;

export const StyledMenuIconWrapper = styled.div`
  border-radius: 50%;
  aspect-ratio: 1;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 100ms ease;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledHeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
  flex: 1;
`;
